import Hero from '../../components/home/Hero';
import PlatformTabsSection from '../../components/home/PlatformTabsSection';

export default function HomePage() {
  return (
    <>
      <Hero />
      <PlatformTabsSection />
    </>
  );
}
